export default "__VITE_ASSET__a202cad1__"